export default "__VITE_ASSET__d1e61615__"